import { render, staticRenderFns } from "./DoctorView.vue?vue&type=template&id=1c124c21&scoped=true&"
import script from "./DoctorView.vue?vue&type=script&lang=js&"
export * from "./DoctorView.vue?vue&type=script&lang=js&"
import style0 from "./DoctorView.vue?vue&type=style&index=0&id=1c124c21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c124c21",
  null
  
)

export default component.exports